import React, { useEffect } from "react";
import styles from "./Modal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../redux/modalStore";
import OutsideClickHandler from "react-outside-click-handler";
import { ReactComponent as CloseIcon } from "../../icons/cross-yellow.svg";

const Modal = ({
  name,
  children,
  title,
  width,
  minWidth,
  maxWidth,
  height,
  onClose,
  isPopupOpen,
  headerAction,
}) => {
  const openedModal = useSelector((state) => state.modal.openedModal);
  const dispatch = useDispatch();

  // Content behind modal can't be scrolled while modal is opened
  useEffect(() => {
    if (openedModal?.name === name) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [openedModal?.name]);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
      return;
    }

    if (!isPopupOpen) {
      dispatch(hideModal());
    }
  };

  return openedModal?.name === name ? (
    <div className={styles.modal}>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          const isIgnoredClick = event?.target?.closest(
            "[data-ignore-outside-click]",
          );
          if (isIgnoredClick) return; // don't close modal

          handleCloseModal();
        }}
        disabled={isPopupOpen}
      >
        <div
          className={styles.header}
          style={{
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth,
          }}
        >
          <div className={styles.title}>{title}</div>
          <div className={styles.rightSide}>
            {headerAction && <div>{headerAction}</div>}
            <CloseIcon className={styles.icon} onClick={handleCloseModal} />
          </div>
        </div>
        <div
          className={styles.box}
          style={{
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth,
            height: height,
          }}
        >
          <div className={styles.children}>{children}</div>
        </div>
      </OutsideClickHandler>
    </div>
  ) : (
    ""
  );
};

export default Modal;
